var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopcomputer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 131.7900 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562-8.20312C9.76562-5.61523 11.9141-3.4668 14.4531-3.4668L117.334-3.4668C119.922-3.4668 122.021-5.61523 122.021-8.20312C122.021-10.8398 119.922-12.9883 117.334-12.9883L108.936-12.9883L108.936-58.6426C108.936-64.1113 106.006-66.9434 100.537-66.9434L31.25-66.9434C26.123-66.9434 22.8516-64.1113 22.8516-58.6426L22.8516-12.9883L14.4531-12.9883C11.9141-12.9883 9.76562-10.8398 9.76562-8.20312Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9316-12.9883L29.9316-56.543C29.9316-58.7891 31.0059-59.9121 33.252-59.9121L98.5352-59.9121C100.781-59.9121 101.904-58.7891 101.904-56.543L101.904-12.9883Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopcomputer);
export default __webpack_public_path__ + "static/media/laptopcomputer.6ab85b0c40f8dfa8ee69791693f13ad9.svg";
export { ForwardRef as ReactComponent };